import api from './api';

const fiiDataImportService = {
  /**
   * Upload FII data file (CSV/Excel)
   * @param {FormData} formData - Contains the file
   */
  uploadFile: async (formData) => {
    return await api.post('/fii_data/upload', formData);
  },

  /**
   * Fetch all FII data import logs
   */
  getLogs: async () => {
    return await api.get('/fii_data/logs');
  },

  /**
   * Get status of a specific FII data import log
   * @param {number|string} id - The log ID
   */
  getLogStatus: async (id) => {
    return await api.get(`/fii_data/status/${id}`);
  }
};

export default fiiDataImportService;
